import React, { createContext, useContext } from "react";

// import * as api from "../api/api";
import { useAuth } from "../contexts/auth_provider";

const UserRole = {
    ADMIN: "admin",
    USER: "user",
};

export const UserContext = createContext();

export const useUser = () => {
    return useContext(UserContext);
};

export const UserProvider = ({ children }) => {
    const { user, userClaims } = useAuth();
    const [role, setRole] = React.useState(UserRole.USER);

    // Setting userRole
    React.useEffect(() => {
        // setRole(userClaims.role) // TODO
        setRole(userClaims?.isAdmin ? UserRole.ADMIN : UserRole.USER);
    }, [userClaims]);

    const value = {
        role, // TODO : not export this
        getUserIsAdmin: () => role === UserRole.ADMIN,
        setUserRole: () => setRole(UserRole.USER),
        setAdminRole: () => setRole(UserRole.ADMIN),
        userClaims,
        user,
    };

    return (
        <UserContext.Provider value={value}>{children}</UserContext.Provider>
    );
};
